import './style.sass';

import { Row, Col, Container, Button } from 'react-bootstrap';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';

const STEP2_DEFAULT_BASE_URL = 'https://beec-learning-modules.s3.us-east-2.amazonaws.com/';
const STEP2_CN_BASE_URL = 'https://beec-step2.oss-cn-beijing.aliyuncs.com/';

export default function Step2({ updateCount }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isCnHost = window.location.hostname === 'learn.beecadvantage.cn';
  const [review, setReview] = useState({});
  const [cheatSheet, setCheatSheet] = useState('');
  const [level, setLevel] = useState('');
  const [cheatSheetExists, setCheatSheetExists] = useState(true);
  const [reviewStepsSubmitted, reviewResponse, questionState, userQuizId, feedbackStatus] =
    useSelector((state) => {
      return [
        state.review.reviewStepsSubmitted,
        state.review.reviewResponse,
        state.review.singleQuestion,
        state.review.userQuizId,
        state.review.feedbackStatus,
      ];
    });

  useEffect(() => {
    if (reviewResponse?.review) {
      setReview(JSON.parse(reviewResponse?.review));
    }
  }, [reviewResponse]);

  useEffect(() => {
    if (questionState) {
      questionState?.tags?.map((item) => {
        if (item.level === 2) {
          setLevel(item.id);
        }
      });
    }
  }, [questionState]);

  useEffect(() => {
    // Fetch or import the HTML file content
    // For simplicity, let's assume you have a local HTML file in your project
    if (level) {
      const step2BaseUrl = isCnHost ? STEP2_CN_BASE_URL : STEP2_DEFAULT_BASE_URL;
      fetch(`${step2BaseUrl}${level}.html`)
        .then((response) => response.text())
        .then((html) => {
          if (html.includes('Access Denied')) {
            setCheatSheetExists(false);
            fetch(`${step2BaseUrl}default.html`)
              .then((response) => response.text())
              .then((html) => {
                if (html.includes('Access Denied')) {
                  setCheatSheetExists(false);
                } else {
                  setCheatSheet(html);
                }
              })
              .catch((error) => {
                console.error('Error fetching HTML file:', error);
              });
          } else {
            setCheatSheet(html);
          }
        })
        .catch((error) => {
          console.error('Error fetching HTML file:', error);
        });
    }
  }, [isCnHost, level]);

  return (
    <>
      <Container className="step-2">
        <div className="ConceptSummary">
          <Row style={{ alignItems: 'center' }}>
            <Col md={8}>
              <h2 className="conceptHead">Concept Summary</h2>
              {/* <p className="ConcptPara">Transition Words</p> */}
            </Col>
            <Col style={{ textAlign: 'right' }} md={4}></Col>
          </Row>
        </div>
        <Row style={{ marginRight: '0' }}>
          <Col md={12}>
            {cheatSheet && (
              <div
                className="passageBox"
                dangerouslySetInnerHTML={{
                  __html: cheatSheet,
                }}
              ></div>
            )}
          </Col>
        </Row>
      </Container>
      <Button
        onClick={() => {
          if (feedbackStatus === 'FINISHED' || feedbackStatus === 'FLAGGED') {
            updateCount();
          } else {
            const temp = review;
            if (temp.length >= 1) {
              if (temp.length === 1) {
                temp.push({
                  time: 20,
                });
              } else if (temp.length > 1) {
                temp[1] = {
                  time: 20,
                };
              }

              dispatch(
                Actions.dispatchUpdateReview({
                  userQuizId: userQuizId,
                  questionId: questionState?.id,
                  reviewFeedback: 'PENDING',
                  review: JSON.stringify(temp),
                }),
              ).then(() => {
                updateCount();
                dispatch(Actions.saveReviewStep(temp));
              });
            }
          }
        }}
        style={{
          background: '#4EA2E2',
          border: 'none',
          padding: '10px 50px',
          position: 'fixed',
          bottom: '0px',
          width: '90%',
          margin: '0 5%',
        }}
      >
        Go to Step 3: Try Again
      </Button>
    </>
  );
}
